// CourseCartCard.jsx
import React, { useCallback, useEffect } from 'react';
import './CourseCartCard.css';
import DeleteIcon from "../../../components/icons/delete-icon";
import { ImageWithFallback } from "../../../components/ImageWithFallback";
import { courseFallBack } from "../../../helpers/shared";
import courseOptionsStore from "../../../store/CourseOptionsStore";

// temp hardcode
const MENTOR_ID_OPTION = '673c6faf2fcf8fdbc6b4320f'

const CourseCartCard = ({ id, title, img, months, options, price, onRemove }) => {
	const handleRemoveClick = (id) => {
		onRemove(id);
	}
	const allCourseOptions = courseOptionsStore.data;

	useEffect(() => {
		if (allCourseOptions !== null)
			return;

		(async () => await courseOptionsStore.fetchAllCoursesOptionsData())();
	}, [allCourseOptions]);

	const getOptionName = (id) => id === MENTOR_ID_OPTION ? 'Чат с куратором' : '';
	// const getOptionName = useCallback((id) => {
	// 	return allCourseOptions?.find((option) => option.id === id)?.description;
	// }, [allCourseOptions]);

	return (
		<div className={"cart-card"}>
			<ImageWithFallback
				src={`${img}`}
				alt={title}
				className={"cart-card__img"}
				fallbackSrc={courseFallBack}
			/>
			<div className={"cart-card__body"}>
				<div className={"cart-card__details"}>
					<span className="cart-card__subtitle">Курс</span>
					<h2 className="cart-card__title">{title}</h2>
					<div className="cart-card__tags">
						{months && <span
							className="cart-card__tag cart-card__tag--outlined">На {months === 12 ? " 12 месяцев" : "1 месяц"}</span>}
						{/*for now there is only one option in the options array */}
						{/*TODO: refactor options later */}
						{Array.isArray(options) && options.length > 0 && (
							<span className="cart-card__tag cart-card__tag--filled">{getOptionName(options[0])}</span>
						)}

					</div>
					<p className="cart-card__price">{price} ₽</p>
				</div>
				<div className={"cart-card__remove-btn"} onClick={() => handleRemoveClick(id)}>
					<DeleteIcon size={20} className={"cart-card__remove-icon"} />
				</div>
			</div>

		</div>
	)

}

export default CourseCartCard;